import React, { useState } from 'react';
import PageLayout from '../components/PageLayout';
import Lightbox from '../components/Lightbox';
import './Immigration.css';

const BlockchainSeedInvestment = () => {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxImage, setLightboxImage] = useState({ src: '', alt: '' });

  const openLightbox = (src, alt) => {
    setLightboxImage({ src, alt });
    setLightboxOpen(true);
  };

  const closeLightbox = () => {
    setLightboxOpen(false);
    setLightboxImage({ src: '', alt: '' });
  };

  return (
    <PageLayout 
      title="Blockchain and Crypto Trading" 
      subtitle="CryptoCurrency Hedge Fund managing large capital for Royal Family Trusts and High Net Worth Individual Investors, providing exposure to the trillion-dollar cryptocurrency market with game-changing DeFi platforms."
    >
      <section className="immigration-section">
        <div className="container">
          <div className="immigration-intro">
            <h2>Cryptocurrency Investment Excellence</h2>
            <p>
              We are a thesis-driven investment firm that invests in cryptocurrencies, tokens, and blockchain companies reshaping markets, taking positions in the most promising blockchain technology in the industry.
            </p>
          </div>
          
          <div className="tab-content">
            <div className="immigration-service-card">
              <div className="service-header">
                <h3>CryptoCurrency Hedge Fund</h3>
              </div>
              <div className="service-content">
                <div className="service-text">
                  <p>
                    Our CryptoCurrency Hedge Fund manages large capital for Royal Family Trusts and High Net Worth Individual Investors in the MENA region, providing strategic exposure to the trillion-dollar cryptocurrency market.
                  </p>
                  
                  <div className="info-section">
                    <h4>Investment Focus</h4>
                    <ul>
                      <li>Large capital management for Royal Family Trusts</li>
                      <li>High Net Worth Individual Investors in MENA region</li>
                      <li>Strategic positions in promising blockchain technologies</li>
                      <li>Exposure to trillion-dollar cryptocurrency market</li>
                    </ul>
                  </div>
                  
                  <div className="info-section">
                    <h4>Investment Strategy</h4>
                    <ul>
                      <li>Thesis-driven investment approach</li>
                      <li>Focus on market-reshaping cryptocurrencies and tokens</li>
                      <li>Investment in blockchain companies and protocols</li>
                      <li>Risk-managed portfolio diversification</li>
                    </ul>
                  </div>
                </div>
                <div className="service-image">
                  <img 
                    src="https://images.unsplash.com/photo-1639762681485-074b7f938ba0?q=80&w=2032&auto=format&fit=crop&ixlib=rb-4.1.0" 
                    alt="Cryptocurrency Hedge Fund" 
                    onClick={() => openLightbox('https://images.unsplash.com/photo-1639762681485-074b7f938ba0?q=80&w=2032&auto=format&fit=crop&ixlib=rb-4.1.0', 'Cryptocurrency Hedge Fund')}
                    style={{ cursor: 'pointer' }}
                  />
                </div>
              </div>
            </div>

            <div className="immigration-service-card">
              <div className="service-header">
                <h3>DeFi Platform Innovation</h3>
              </div>
              <div className="service-content">
                <div className="service-text">
                  <p>
                    We focus on game-changing DeFi platforms that are revolutionizing the financial industry, providing our investors with early access to groundbreaking decentralized finance opportunities.
                  </p>
                  
                  <div className="info-section">
                    <h4>DeFi Investment Areas</h4>
                    <ul>
                      <li>Game-changing decentralized finance platforms</li>
                      <li>Revolutionary financial protocols and services</li>
                      <li>Yield farming and liquidity mining opportunities</li>
                      <li>Next-generation DeFi infrastructure projects</li>
                    </ul>
                  </div>
                  
                  <div className="info-section">
                    <h4>Platform Benefits</h4>
                    <ul>
                      <li>Early access to breakthrough DeFi innovations</li>
                      <li>Portfolio exposure to high-growth potential</li>
                      <li>Diversified DeFi ecosystem participation</li>
                      <li>Professional risk assessment and management</li>
                    </ul>
                  </div>
                </div>
                <div className="service-image">
                  <img 
                    src="https://images.unsplash.com/photo-1621761191319-c6fb62004040?q=80&w=2074&auto=format&fit=crop&ixlib=rb-4.1.0" 
                    alt="DeFi Platform Innovation" 
                    onClick={() => openLightbox('https://images.unsplash.com/photo-1621761191319-c6fb62004040?q=80&w=2074&auto=format&fit=crop&ixlib=rb-4.1.0', 'DeFi Platform Innovation')}
                    style={{ cursor: 'pointer' }}
                  />
                </div>
              </div>
            </div>

            <div className="immigration-service-card">
              <div className="service-header">
                <h3>Crypto Payment Gateway Integration</h3>
              </div>
              <div className="service-content">
                <div className="service-text">
                  <p>
                    We provide comprehensive crypto payment gateway integration services for websites, enabling businesses to accept cryptocurrency payments and participate in the digital economy revolution.
                  </p>
                  
                  <div className="info-section">
                    <h4>Integration Services</h4>
                    <ul>
                      <li>Crypto payment gateway integration for websites</li>
                      <li>Multi-cryptocurrency payment processing</li>
                      <li>Secure transaction handling and management</li>
                      <li>Real-time conversion and settlement options</li>
                    </ul>
                  </div>
                  
                  <div className="info-section">
                    <h4>Technology Solutions</h4>
                    <ul>
                      <li>Advanced blockchain payment infrastructure</li>
                      <li>Seamless e-commerce platform integration</li>
                      <li>Enterprise-grade security protocols</li>
                      <li>Comprehensive API and SDK solutions</li>
                    </ul>
                  </div>
                </div>
                <div className="service-image">
                  <img 
                    src="https://images.unsplash.com/photo-1551288049-bebda4e38f71?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0" 
                    alt="Crypto Payment Gateway" 
                    onClick={() => openLightbox('https://images.unsplash.com/photo-1551288049-bebda4e38f71?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0', 'Crypto Payment Gateway')}
                    style={{ cursor: 'pointer' }}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="immigration-service-card">
            <div className="service-header">
              <h3>Why Choose Our Crypto Trading Solutions?</h3>
            </div>
            <div className="service-content">
              <div className="service-text">
                <p style={{fontSize: '1.1rem', marginBottom: '30px'}}>
                  Our mission is to demystify investment in cryptocurrency and create conversations and opportunities for our investors to learn more about this new industry and earn returns not seen anywhere else.
                </p>
                
                <div className="info-section">
                  <h4>Market Expertise</h4>
                  <p>Thesis-driven investment approach with focus on the most promising blockchain technologies in the industry.</p>
                </div>
                
                <div className="info-section">
                  <h4>Institutional Grade</h4>
                  <p>Managing large capital for Royal Family Trusts and High Net Worth Individual Investors with professional oversight.</p>
                </div>
                
                <div className="info-section">
                  <h4>Innovation Focus</h4>
                  <p>Strategic positioning in game-changing DeFi platforms and market-reshaping cryptocurrency opportunities.</p>
                </div>
                
                <div className="info-section">
                  <h4>Education & Returns</h4>
                  <p>Creating learning opportunities while delivering returns not seen in traditional investment vehicles.</p>
                </div>
                
                <div style={{marginTop: '32px', padding: '24px', background: 'rgba(0,0,0,0.05)', borderRadius: '12px'}}>
                  <p style={{margin: '0', fontSize: '1rem', lineHeight: '1.6', fontStyle: 'italic'}}>
                    "Our mission at Rayad Group is to demystify investment in cryptocurrency and create conversations and opportunities for our investors to learn more about this new industry and earn returns not seen anywhere else so that they can get their money to work for them."
                  </p>
                </div>
              </div>
              <div className="service-image">
                <img 
                  src="https://images.unsplash.com/photo-1518186285589-2f7649de83e0?q=80&w=2074&auto=format&fit=crop&ixlib=rb-4.1.0" 
                  alt="Crypto Trading Excellence" 
                  onClick={() => openLightbox('https://images.unsplash.com/photo-1518186285589-2f7649de83e0?q=80&w=2074&auto=format&fit=crop&ixlib=rb-4.1.0', 'Crypto Trading Excellence')}
                  style={{ cursor: 'pointer' }}
                />
              </div>
            </div>
          </div>
          
          <div className="immigration-page-cta-section">
            <h3>Start Your Crypto Journey</h3>
            <p>Ready to access institutional-grade cryptocurrency investment opportunities? Contact our blockchain specialists.</p>
            <a href="/contact" className="btn immigration-btn-primary">Get Started</a>
          </div>
        </div>
      </section>
      
      <Lightbox 
        isOpen={lightboxOpen}
        imageSrc={lightboxImage.src}
        imageAlt={lightboxImage.alt}
        onClose={closeLightbox}
      />
    </PageLayout>
  );
};

export default BlockchainSeedInvestment;